"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { HeartHandshake } from "@jobteaser/spark/components/Icons/HeartHandshake"

import { useJobAdsFilterNavigation } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"
import { useSecondaryFilters } from "@/modules/jobAds/client/hooks/useSecondaryFilters"
import { FilterButton } from "@/modules/landingSearch/components/FilterButton/FilterButton"

import styles from "./JobsWithImpactFilterShortcut.module.css"

type JobsWithImpactFilterShortcutProps = PropsWithChildren<{
  className?: string
}>

export const JobsWithImpactFilterShortcut: FunctionComponent<JobsWithImpactFilterShortcutProps> = ({
  children,
  className,
}) => {
  const { navigateWithUpdatedQueryParams } = useJobAdsFilterNavigation()
  const { secondaryFilters } = useSecondaryFilters()
  const isActive = secondaryFilters.jobWithImpact.some(({ value }) => value === "job_with_impact")

  const handleClick = (): void => {
    navigateWithUpdatedQueryParams({
      availableFilters: { job_with_impact: isActive ? undefined : "job_with_impact" },
    })
  }

  return (
    <FilterButton
      className={clsx(className, styles.button, {
        [styles.active]: isActive,
      })}
      data-testid="job-ads-secondary-filters-jobs-with-impact-button"
      icon={HeartHandshake}
      isActive={isActive}
      onClick={handleClick}
    >
      {children}
    </FilterButton>
  )
}
